module.exports = __webpack_public_path__ + "assetst/img/android-frame.0435043f.svg";